(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('LeafletService', LeafletService);

  LeafletService.$inject = [
    '$q'
  ];

  /* eslint-disable */ 
  function LeafletService($q) {
    //////////////////////////////////////////
    // Service data
    const maps = {};

    //////////////////////////////////////////
    // Service object declaration
    const service = {
      createMap: CreateMap,
      getMap: GetMap,
      getBounds: GetBounds,
      generateControl: GenerateControl,
      generatePolygon: GeneratePolygon,
      addToMap: AddToMap,
      removeFromMap: RemoveFromMap,
      createMarker: CreateMarker,
      createPolyline: CreatePolyline,
      createCircle: CreateCircle,
      createIconByNumber: CreateIconByNumber,
      getIconForNumberMarker: GetIconForNumberMarker,
      fontAwesomeIcon,
      boundsFromCoordinates
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function CreateMap(id, options) {
      return $q(function(resolve) {
        if (maps[id]) {
          maps[id].remove();
        }

        maps[id] = L.map(id, options);
        L.tileLayer('https://www.google.com.hk/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}').addTo(maps[id]);
        maps[id].on('unload', function() {
          delete maps[id];
        });

        resolve(maps[id]);
      });
    }

    function CreateMarker(position, icon) {
      if (typeof icon === 'string') {
        icon = L.icon({
          iconUrl: icon,
          iconAnchor: [17, 40],
          popupAnchor: [0, -44]
        });
      } else if (!icon) {
        icon = null;
      }

      return L.marker(position, {
        icon
      });
    }

    function GetMap(id) {
      return maps[id] || false;
    }

    function GetBounds(corner1, corner2) {
      return L.latLngBounds(corner1, corner2);
    }

    function GenerateControl(config) {
      const control = L.control[config.type](config.options || null);
      if (config.mapId) {
        service.addToMap(control, config.mapId);
      }
      return control;
    }

    function GeneratePolygon(config) {
      const polygon = L.polygon(config.coordinates, config.options || null);
      if (config.mapId) {
        service.addToMap(polygon, config.mapId);
      }
      return polygon;
    }

    function AddToMap(object, map) {
      if (typeof map === 'string') {
        return object.addTo(maps[map]);
      }
      return object.addTo(map);
    }

    function RemoveFromMap(object, map) {
      if (typeof map === 'string') {
        return object.removeFrom(maps[map]);
      }
      return object.removeFrom(map);
    }

    function CreatePolyline(config) {
      return L.polyline(config.path, config.options || null);
    }

    function CreateCircle(config) {
      const circle = L.circleMarker(config.coordinates, config.options || null);
      if (config.mapId) {
        service.addToMap(circle, config.mapId);
      }
      return circle;
    }

    function CreateIconByNumber(number, bgColor, textColor) {
      return L.icon({
        iconUrl: GetIconForNumberMarker(number, bgColor, textColor),
        iconAnchor: [10, 34],
        popupAnchor: [0, -34]
      });
    }

    function GetIconForNumberMarker(number, bgColor ='47a643', textColor ='ffffff') {
      const source = `
        <svg width="26" height="38" version="1.1" viewBox="0 0 6.87918 10.0542" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="linearGradient1503" x1="17.718" x2="17.719" y1="22.145" y2="37.68" gradientTransform="matrix(.622585 0 0 .623061 -7.61267 -13.56)" gradientUnits="userSpaceOnUse">
              <stop stop-color="#${bgColor}" offset="0"/>
            </linearGradient>
          </defs>
          <path d="m3.41812 0.238169a3.04506 3.04738 0 0 0-3.04487 3.04719 3.04506 3.04738 0 0 0 0.456863 1.60151 3.04506 3.04738 0 0 0 6.226e-4 0.00123l2.58802 5.02921 2.60342-5.05956 0.00123-0.00266a3.04506 3.04738 0 0 0 0.439483-1.56992 3.04506 3.04738 0 0 0-3.04487-3.04719z" fill="url(#linearGradient1503)" stroke="#${bgColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width=".26458"/>
          <path d="m3.41812 0.505674c-1.52681 9.8e-5 -2.76445 1.23868-2.76454 2.76665 6.692e-4 0.513843 0.132072 0.874384 0.41481 1.45406 0.282738 0.579672 1.56692 3.2229 2.35028 4.74534 0 0 2.24933-4.53387 2.36378-4.77179 0.114449-0.237919 0.394458-0.982499 0.400114-1.4279-9.89e-5 -1.52797-1.23774-2.76656-2.76454-2.76665z" fill="none" stroke="#${bgColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width=".25289"/>
          <text transform="scale(.999618 1.00038)" x="3.2947297" y="4.4592853" fill="#{textColor}" font-family="FreeSans" font-size="3.35471px" font-weight="600" letter-spacing="0px" stroke-width=".264585" text-align="center" text-anchor="middle" word-spacing="0px" style="line-height:1.25" xml:space="preserve"><tspan x="3.2947297" y="4.4592853" fill="#${textColor}" font-family="FreeSans" font-size="3.35471px" font-weight="600" stroke-width=".264585" text-align="center" text-anchor="middle">${number}</tspan></text>
        </svg>
      `;

      return `data:image/svg+xml;base64,${btoa(source)}`;
    }

    function fontAwesomeIcon(name, color) {
      return L.icon.fontAwesome({
        iconClasses: `fa fa-${name}`,
        markerColor: color,
        iconColor: '#000'
      });
    }

    function boundsFromCoordinates(coordinates) {
      const latLngs = _.flatten(coordinates).map((coordinate) => [coordinate[1], coordinate[0]]);
      return L.latLngBounds(latLngs);
    }
  }
}());

// Translations for Leaflet.Draw
L.drawLocal.draw.toolbar.actions.title = 'Cancelar desenho';
L.drawLocal.draw.toolbar.actions.text = 'Cancelar';
L.drawLocal.draw.toolbar.finish.title = 'Concluir desenho';
L.drawLocal.draw.toolbar.finish.text = 'Concluir';
L.drawLocal.draw.toolbar.undo.title = 'Apagar último ponto desenhado';
L.drawLocal.draw.toolbar.undo.text = 'Apagar último ponto';
L.drawLocal.draw.toolbar.buttons.polyline = 'Desenhar polilinha';
L.drawLocal.draw.toolbar.buttons.polygon = 'Desenhar polígono';
L.drawLocal.draw.toolbar.buttons.rectangle = 'Desenhar retângulo';
L.drawLocal.draw.toolbar.buttons.circle = 'Desenhar círculo';
L.drawLocal.draw.toolbar.buttons.marker = 'Desenhar marcador';
L.drawLocal.draw.toolbar.buttons.circlemarker = 'Desenhar marcador circular';
L.drawLocal.draw.handlers.circle.tooltip.start = 'Clique e arraste para desenhar um círculo';
L.drawLocal.draw.handlers.circle.radius = 'Raio';
L.drawLocal.draw.handlers.circlemarker.tooltip.start = 'Cique para desenhar um marcador circular';
L.drawLocal.draw.handlers.marker.tooltip.start = 'Clique para posicionar um marcador';
L.drawLocal.draw.handlers.polygon.tooltip.start = 'Clique para iniciar a forma';
L.drawLocal.draw.handlers.polygon.tooltip.cont = 'Clique para adicionar outro ponto';
L.drawLocal.draw.handlers.polygon.tooltip.end = 'Clique no primeiro ponto para finalizar';
L.drawLocal.draw.handlers.polyline.error = '<strong>Erro:</strong> as arestas não podem se cruzar!';
L.drawLocal.draw.handlers.polyline.tooltip.start = 'Clique para para iniciar a linha';
L.drawLocal.draw.handlers.polyline.tooltip.cont = 'Clique para adicionar outro ponto';
L.drawLocal.draw.handlers.polyline.tooltip.end = 'Clique no primeiro ponto para finalizar';
L.drawLocal.draw.handlers.rectangle.tooltip.start = 'Clique e arraste para desenhar um retângulo';
L.drawLocal.edit.toolbar.actions.save.title = 'Salvar alterações';
L.drawLocal.edit.toolbar.actions.save.text = 'Salvar';
L.drawLocal.edit.toolbar.actions.cancel.title = 'Cancelar alterações';
L.drawLocal.edit.toolbar.actions.cancel.text = 'Cancelar';
L.drawLocal.edit.toolbar.actions.clearAll.title = 'Limpar mapa';
L.drawLocal.edit.toolbar.actions.clearAll.text = 'Limpar';
L.drawLocal.edit.toolbar.buttons.edit = 'Editar';
L.drawLocal.edit.toolbar.buttons.editDisabled = 'Não há o que editar';
L.drawLocal.edit.toolbar.buttons.remove = 'Apagar';
L.drawLocal.edit.toolbar.buttons.removeDisabled = 'Não há o que apagar';
L.drawLocal.edit.handlers.edit.tooltip.text = 'Arraste as alças ou marcadores para editar';
L.drawLocal.edit.handlers.edit.tooltip.subtext = 'Clique em cancelar para desfazer alterações';
L.drawLocal.edit.handlers.remove.tooltip.text = 'Clique para remover';
